
<div class="container-fluid p-0 m-0">

    <app-poscontent  status="Avoiré"></app-poscontent>
</div>
